import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { PortfolioViewMenuAdditionalInfoClient } from "../../../../../Wrap/Api/Dashboard/PortfolioViewMenuAdditionalInfo";
import { PortfolioRegularPaymentClient } from "../../../../../Wrap/Api/Payments/PortfolioRegularPayment";
import { PortfolioViewMenuAdditionalInfoDisaptcher } from "../Store/Variable";

export class PortfolioViewActionMenuAdditionalInfoAction {
    public static get(hierarchyId: string) {
        const client = new PortfolioViewMenuAdditionalInfoClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            PortfolioViewMenuAdditionalInfoDisaptcher.dispatch({ payload: data, actionType: ActionType.Success });
        });
    }

    public static getRegularPayment(hierarchyId: string, callback) {
        const client = new PortfolioRegularPaymentClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            if (callback) {callback(data);}
        });
    }
}
